import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

createApp(App)
.use(VueGtag, {
    config: { id: "G-JDRP4XC3YW" } // 측정 ID 입력
  },router)
.use(router)
.mount('#app');
